import { Component, Input } from '@angular/core';
import { ShareDialogComponent } from '../../dialogs/share-dialog/share-dialog.component';
import { BankService } from 'src/app/pages/user/profile/services/bank.service';
import { FundraiserService } from '../../../services/fundraiser.service';
import { MatDialog } from '@angular/material/dialog';
import { MediaObserver } from '@angular/flex-layout';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { DonationService } from 'src/app/pages/donation/services/donation.service';
import { Router } from '@angular/router';
import { Fundraiser } from '../../../models/fundraiser';
import { FundraiserCardData } from 'src/app/shared/interfaces/fundraiser-card-interface';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DonationProgressPercentageComponent } from '../../../../../shared/components/fundraiser-card/shared/donation-progress-percentage/donation-progress-percentage.component';
import { DaysLeftViewComponent } from '../../../../../shared/components/fundraiser-card/shared/days-left-view/days-left-view.component';
import { DonationProgressBarComponent } from '../../../../../shared/components/fundraiser-card/shared/donation-progress-bar/donation-progress-bar.component';
import { NgIf } from '@angular/common';
import { AmountViewComponent } from '../../../../../shared/components/fundraiser-card/shared/amount-view/amount-view.component';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
	selector: 'app-fundraiser-donation-small-card',
	templateUrl: './fundraiser-donation-small-card.component.html',
	standalone: true,
	imports: [
		FlexModule,
		MatButtonModule,
		AmountViewComponent,
		NgIf,
		DonationProgressBarComponent,
		DaysLeftViewComponent,
		DonationProgressPercentageComponent,
		MatTooltipModule,
		MatIconModule,
		MatProgressSpinnerModule,
	],
})
export class FundraiserDonationSmallCardComponent {
	@Input() fundraiserCardData!: FundraiserCardData;
	@Input() targetAmount: number = 0;
	@Input() raisedAmount: number = 0;
	@Input() selectedFundraiser: Fundraiser | undefined;
	@Input() isDraftOrClosed: boolean = false;
	@Input() isLoggedIn: boolean = false;
	@Input() isOpen: boolean = false;
	temp: boolean = false;
	progress: number = 0;
	disableDonation: boolean = false;
	donationService: any;
	router: any;
	slug: string = '';
	locale: string;
	stripeStatus: any;
	stripeNotificationCheck: boolean = false;
	donationToolTipMessage: string = 'The fundraiser has been closed';
	stripeChargeStatus!: boolean;
	isLoading: boolean = false;
	totalOfflineDonationAmount: number = 0;
	totalOnlineDonationAmount: number = 0;
	currency_symbol: any;
	chargesEnabled!: boolean;

	constructor(
		donationService: DonationService,
		router: Router,
		private _AccountService: AccountService,
		public _media: MediaObserver,
		public dialog: MatDialog,
		public fundraiserService: FundraiserService,
		public _bankService: BankService
	) {
		this.locale = this._AccountService.getLocaleId();
		this.donationService = donationService;
		this.router = router;
	}

	ngOnInit(): void {
		this.fundraiserService
			.getStripeChargesStatus(this.selectedFundraiser?.slug)
			.subscribe((res: any) => {
				this.chargesEnabled = res?.data?.charges_enabled;
			});

		/** *Get Stripe Verification Check to disable/enable donation button */
		if (this.isLoggedIn == true && this._AccountService.checkHeaders()) {
			this._bankService.getStripeStatus().subscribe((res: any) => {
				this.stripeStatus = res?.data;
				//Checking that either user is verified with Stripe or not
				if (this.stripeStatus?.charges_enabled == false) {
					this.stripeNotificationCheck = true;
				} else {
					this.stripeNotificationCheck = false;
					this.donationToolTipMessage =
						'Account verification is mandatory to receive donation and payouts.';
				}
			});
		}

		if (this.targetAmount != 0) {
			this.progress = (this.raisedAmount / this.targetAmount) * 100;
			this.temp = true;
		}

		if (this.progress > 100) {
			this.disableDonation = false;
		}

		// this.fundraiserService
		// 	.getStripeChargesStatus(this.selectedFundraiser?.slug)
		// 	.subscribe((res: any) => {
		// 		this.stripeChargeStatus = res?.data?.status;
		// 	});

		this.getTotalOfflineDonations();
		this.fundraiserService.getOfflineDonation().subscribe((res) => {
			this.getTotalOfflineDonations();
		});
	}
	/** *Donate */
	donate() {
		this.isLoading = true;
		this.donationService.setSelectedFundraiser(this.selectedFundraiser);
		this.router.navigate(['donate/' + this.selectedFundraiser?.slug]);
	}

	openShareDialog() {
		this.dialog.open(ShareDialogComponent, {
			panelClass: 'max-w-100--panelClass',
			maxHeight: '89vh',
			maxWidth: '90vw',
			width: '95vw',
			data: {
				fundraiser: this.selectedFundraiser,
				data: this.fundraiserCardData,
			},
		});
	}

	getTotalOfflineDonations() {
		const slug = this.selectedFundraiser?.slug;
		if (slug) {
			this.fundraiserService
				.getAllOfflineDonation(slug)
				.subscribe((res: any) => {
					this.totalOfflineDonationAmount = res?.data?.result?.total_amount;
					this.totalOnlineDonationAmount =
						this.fundraiserCardData.donationReceivedAmount;
					this.currency_symbol = this.fundraiserCardData.currency_symbol;
					this.totalOfflineDonationAmount = Number(
						res.data.result.total_amount
					);
					this.fundraiserCardData = {
						...(this.fundraiserCardData as any),
						totalOfflineDonationAmount: this.totalOfflineDonationAmount,
					};
				});
		}
	}

	scrollToDonation() {
		const donationElement = document.querySelector('#fullDonationCard');
		if (donationElement) {
			donationElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}
}
